/**
 * Escapes the five reserved XML characters: `& < > " '`
 */
export const escapeXmlEntities = (value: string): string =>
    value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;")
